import { render } from "./openquery.vue?vue&type=template&id=7ecddb07"
import script from "./openquery.vue?vue&type=script&lang=js"
export * from "./openquery.vue?vue&type=script&lang=js"

import "./openquery.vue?vue&type=style&index=0&id=7ecddb07&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__